// extracted by mini-css-extract-plugin
module.exports = {"landingHighlightItem":"LandingHighlightItem_landingHighlightItem__1j4i7","text":"LandingHighlightItem_text__3ot7X"};